import { useSelector } from 'react-redux'

export default () => {
  const frameworkSkills = useSelector(
    state => state.manifest.data.framework_skills
  )
  const frameworkSkillGroups = useSelector(
    state => state.manifest.data.framework_skill_groups
  )

  return { frameworkSkills, frameworkSkillGroups }
}
